import React from "react";

import "./styles/header.css";

import Logo from "../assets/logo.png";

export default function Header() {
  return (
    <header>
      <img src={Logo} alt="logoArenaCentral" />
      <div className="textHeader">
        <h1>Arena Central</h1>
        <h4>
          Consulte os <b>horários disponíveis</b>
        </h4>
        <p>
          Clique no dia e no horário que deseja marcar, e você será redirecionado para nosso o WhatsApp!
        </p>
      </div>
    </header>
  );
}
